"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HybridBikeIcon = HybridBikeIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function HybridBikeIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 32 22"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.3362 1.49898C15.3362 1.49898 11.9782 1.27716 11.7564 1.49898C11.1994 2.05597 10.5124 4.17284 9.93819 6.27202C9.28217 8.67007 8.77325 11.045 8.77325 11.045M18.4 6.27202L13.6247 5.00039L10.5631 4.15687L16.8 11.045M18.4 6.27202L16.8 11.045M18.4 6.27202L19.2 4.20039M16.8 11.045H23.6M18 3.80039L20.4 4.60039",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "8.77302",
    cy: "11.0445",
    fill: "none",
    r: "4.17302",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "23.973",
    cy: "11.0445",
    fill: "none",
    r: "4.17302",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.40002 20.2388L10 17.4004L15.6 20.2388L21.6 17.4004L27.2 20.2388",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.2"
  }));
}